import { makeStyles } from "@material-ui/styles";

export const useConfigStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    root1: {
      flexShrink: 0,
      marginLeft: theme.spacing(2.5),
    },
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    configTitle: {
      fontWeight: "bold",
      fontSize: "1.7em",
    },
    mainGridStyle: {
      paddingTop: "1em",
      paddingLeft: "1em",
      paddingRight: "1em",
    },
    SearchInput: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    searchPaper: {
      padding: "2px 4px",
      display: "flex",
      alignItems: "center",
      width: 400,
    },
    textFieldStyles: {
      paddingLeft: "1em",
      marginTop: "1em",
    },
    textFieldStyles1: {
      paddingLeft: "2em",
    },
    buttonsStyles: {
      paddingTop: "2em",
    },
    fieldLabelStyles: {
      paddingBottom: "1em",
      fontWeight: "bold",
    },
    editIcon: {
      width: ".90em",
      height: ".90em",
      color: "#3d5a79 !important",
    },
    editIconMargin: {
      marginRight: theme.spacing(1),
      backgroundColor: "white", //"#8bc34a",
      boxShadow: "none",
      borderRadius: "0.3em",
      "&:hover": {
        backgroundColor: "#717d8a",
      },
    },
    checkbox: {
      marginTop: "1.5em",
    },
  })
);
